module.exports = __webpack_public_path__ + "static/36氪-最具竞争力企业top100-ee00afa14bb6e43a52cff737626b2e43.png";